import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"

import { DashboardChartsArea } from "@/components/dashboard/charts-area"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"

export function DashboardPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const searchParamsObject = Object.fromEntries(
    searchParams.entries()
  )

  return (
    <DashboardContainer>
      <Header>
        <h1 className="page-title">
          {t("pages.dashboard.title")}
        </h1>
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <DashboardChartsArea
          searchParams={searchParamsObject}
        />
      </section>
    </DashboardContainer>
  )
}
